// Shared product navigation used by both the landing header mega-menu and the
// landing "Solutions" section. Keep this the single source of truth for product links.
import {
  MessageCircle, ScanLine, FileSpreadsheet, FileText, ReceiptText,
  PieChart, Calculator, Building2, FileCheck2, Sparkles, Car, Briefcase,
} from 'lucide-react';

export const PRODUCT_GROUPS = [
  {
    title: 'Bookkeeping',
    icon: Sparkles,
    items: [
      { label: 'WhatsApp Accounting', to: '/whatsapp-accounting', desc: 'Accounting on WhatsApp', icon: MessageCircle },
      { label: 'AI Bookkeeping', to: '/ai-bookkeeping', desc: 'Auto-categorized by AI', icon: Sparkles },
      { label: 'Expense Tracking', to: '/expense-tracking', desc: 'Track expenses by text', icon: ReceiptText },
      { label: 'Mileage Tracking', to: '/mileage-tracking', desc: '2026 IRS rate, by date', icon: Car },
      { label: 'Freelancer Bookkeeping', to: '/freelancer-bookkeeping', desc: 'For the self-employed', icon: Briefcase },
      { label: '1099 Bookkeeping', to: '/1099-bookkeeping', desc: 'Schedule C income & expenses', icon: FileText },
    ],
  },
  {
    title: 'Capture & Scan',
    icon: ScanLine,
    items: [
      { label: 'WhatsApp Bookkeeping', to: '/whatsapp-bookkeeping', desc: 'Track expenses by texting', icon: MessageCircle },
      { label: 'Invoice & Receipt Scanner', to: '/invoice-scanner', desc: 'Bulk-scan receipts with AI', icon: ScanLine },
      { label: 'Receipt to Excel', to: '/receipt-to-excel', desc: 'Scan receipts → .xlsx', icon: FileSpreadsheet },
      { label: 'Receipt to CSV', to: '/receipt-to-csv', desc: 'Scan receipts → CSV', icon: FileSpreadsheet },
      { label: 'Invoice to Excel', to: '/invoice-to-excel', desc: 'Extract invoice data → Excel', icon: FileSpreadsheet },
      { label: 'PDF Invoice to Excel', to: '/convert-pdf-invoice-to-excel', desc: 'Convert PDF invoices to Excel', icon: FileSpreadsheet },
      { label: 'Scan Receipts to PDF', to: '/scan-receipts-to-pdf', desc: 'Digitize & archive receipts', icon: FileText },
      { label: 'Schedule C Receipt Scanner', to: '/schedule-c-receipt-scanner', desc: 'US IRS Schedule C receipts', icon: FileCheck2 },
      { label: 'VAT Receipt Scanner', to: '/vat-receipt-scanner', desc: 'UAE & Saudi VAT receipts', icon: ReceiptText },
    ],
  },
  {
    title: 'Invoice & Get Paid',
    icon: ReceiptText,
    items: [
      { label: 'Invoicing', to: '/invoicing', desc: 'Invoice clients on WhatsApp', icon: ReceiptText },
    ],
  },
  {
    title: 'Reports & Export',
    icon: PieChart,
    items: [
      { label: 'Export to Excel', to: '/export-to-excel', desc: 'CSV & Excel export center', icon: FileSpreadsheet },
      { label: 'Tax Calculator', to: '/tools/1099-tax-calculator', desc: 'Free US, UK, Canada & GCC estimator', icon: Calculator },
    ],
  },
  {
    title: 'For Teams',
    icon: Building2,
    items: [
      { label: 'MoneyFeed for Business', to: '/business', desc: 'Bulk scanning, team & exports', icon: Building2 },
      { label: 'For Accountants', to: '/for-accountants', desc: 'Tax-ready client data', icon: FileCheck2 },
    ],
  },
];

export const COMPARE_LINKS = [
  { label: 'vs QuickBooks', to: '/moneyfeed-vs-quickbooks' },
  { label: 'vs FreshBooks', to: '/moneyfeed-vs-freshbooks' },
  { label: 'vs Keeper', to: '/moneyfeed-vs-keeper' },
];

export const RESOURCE_LINKS = [
  { label: 'What is MoneyFeed?', to: '/about-moneyfeed' },
  { label: 'All Features', to: '/features' },
  { label: 'Integrations', to: '/integrations' },
  { label: 'Supported Countries', to: '/supported-countries' },
  { label: 'Tax Support', to: '/tax-support' },
  { label: 'Security', to: '/security' },
  { label: 'See Demo', to: '/demo' },
  { label: 'Blog', to: '/blog' },
];
